module.exports = __webpack_public_path__ + "static/media/Main_main2.21b8ee73.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/Main_main2.jpeg
// module id = 546
// module chunks = 0